module.exports = __webpack_public_path__ + "static/media/animated_kritagya.138f2941.png";